(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iaj-product-main"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('iaj-product'))customElements.define('iaj-product',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);this.image=this.querySelector('.iaj-pdp__image');this.zoom=this.querySelector('.iaj-pdp__zoom');this.dialog=this.querySelector('dialog');this.addEventListener('change',e=>{if(e.target.matches('[data-option]'))this.updateVariant()});this.addEventListener('click',e=>{const thumb=e.target.closest('[data-image-src]');if(thumb)this.setImage(thumb.dataset.imageSrc,thumb.dataset.imageAlt);const quantity=e.target.closest('[data-quantity]');if(quantity){const input=this.querySelector('[name="quantity"]');input.value=Math.max(1,(parseInt(input.value)||1)+Number(quantity.dataset.quantity))}if(e.target.closest('[data-open-image]')&&!e.target.closest('[data-open-image]').disabled&&this.dialog)this.dialog.showModal();if(e.target.closest('[data-close-image]')&&this.dialog)this.dialog.close()});if(this.dialog)this.dialog.addEventListener('click',e=>{if(e.target===this.dialog)this.dialog.close()})}
 setImage(src,alt){if(this.image){this.image.removeAttribute('srcset');this.image.src=src;this.image.alt=alt||''}if(this.zoom){this.zoom.removeAttribute('srcset');this.zoom.src=src;this.zoom.alt=alt||''}}
 updateVariant(){const options=Array.from(this.querySelectorAll('[data-option]')).map(e=>e.value);const variant=this.variants.find(v=>v.options.every((o,i)=>o===options[i]));const submits=this.querySelectorAll('[data-submit]');const hidden=this.querySelector('[data-variant-id]');if(!variant){if(hidden)hidden.disabled=true;submits.forEach(s=>{s.disabled=true;s.textContent=s.dataset.unavailableLabel||this.dataset.unavailable});return}if(hidden){hidden.disabled=false;hidden.value=variant.id}submits.forEach(s=>{s.disabled=!variant.available;s.textContent=variant.available?(s.dataset.addLabel||this.dataset.add):(s.dataset.soldLabel||this.dataset.sold)});const money=n=>new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(n/100);this.querySelectorAll('[data-price]').forEach(e=>e.textContent=money(variant.price));const sale=variant.compare_at_price>variant.price;this.querySelectorAll('[data-compare]').forEach(e=>{e.hidden=!sale;e.textContent=sale?money(variant.compare_at_price):''});this.querySelectorAll('[data-sale]').forEach(e=>e.hidden=!sale);if(variant.featured_image)this.setImage(variant.featured_image.src,variant.featured_image.alt);else if(this.dataset.defaultImage)this.setImage(this.dataset.defaultImage,this.dataset.defaultAlt);const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();
})();
